export const MAX_PARTICLES = 100;
export const SNOW_RADIUS = 5;
export const MAX_SNOWFLAKES_RADIUS = 15;
export const MIN_SNOWFLAKES_RADIUS = 0.5;
